module.exports = __webpack_public_path__ + "img/connect-elements.d4abedf2.svg";